import { ErrorBase } from '~/utils/error-base';

type ErrorName = 'INVALID_JWT';

export class MiddlewareError extends ErrorBase<ErrorName> {}
